import React from 'react';
import { HeaderTemplate, Stepper } from 'web-library';
import ExamTypeUuidDisplay from '../../modules/examRegistration/components/ExamTypeUuidDisplay';
import ExamTitle from '../../modules/examRegistration/components/ExamTitle';
import ExamSelectSubject from '../../modules/examRegistration/components/ExamSelectSubject';

interface SelectSubjectPageProps {
  routeSteps: { label: string }[];
}

const SelectSubject = ({ routeSteps }: SelectSubjectPageProps) => (
  <>
    <ExamTitle />
    <HeaderTemplate>
      <ExamTypeUuidDisplay />
      <div>
        <Stepper activeStep={0} steps={routeSteps} />
      </div>
    </HeaderTemplate>
    <ExamSelectSubject />
  </>
);

export default SelectSubject;
